import "./App.css";

import Axios from "axios";
import { useEffect, useState } from "react";
import { Route, Routes, useNavigate, Navigate } from "react-router-dom";
import { ThemeProvider } from "styled-components";

import ErrorPage from "./UI/ErrorPage";
import Footer from "./UI/Footer";
import Header from "./UI/Header";
import LandingPage from "./UI/LandingPage";
import VerifiedPage from "./UI/VerifiedPage";

import { Frame, Main } from "./StyledComponents/AppStyles";

const theme = {
  primaryYellow: "#EECA30",
  primaryPurple: "#9944CB",
  secondarySand: "#FFF8DB",
  secondaryLavender: "#E1DBFF",
  regGray: "#ACACA1",
  darkGray: "#56564C",
  regBlack: "#191917",
  regWhite: "#FFFDFC",
};

function App() {
  const navigate = useNavigate();

  const [error, setError] = useState(false);

  const [connections, setConnections] = useState({
    firstConnection: false,
    secondConnection: false,
  });
  const [invitations, setInvitations] = useState({
    firstInvitation: {},
    secondInvitation: {},
  });
  const [verifiedCredAttributes, setVerifiedCredAttributes] = useState({});

  const checkConnection = (firstAttempt, id) => {
    const abortController = new AbortController();
    const signal = abortController.signal;

    Axios.get(`/api/connections/${id}`, { signal })
      .then((response) => {
        console.log("Connection response: ", response.data);
        if (firstAttempt) {
          setConnections({
            firstConnection: true,
            secondConnection: false,
          });
          fetchInvitation(false);
        } else {
          setConnections({
            firstConnection: connections.firstConnection,
            secondConnection: true,
          });
        }
      })
      .catch((error) => {
        console.error("Connection Error: ", error);
        setError(true);
      });
  };

  const fetchInvitation = (firstAttempt) => {
    console.log("Fetching invitation...");
    Axios.post("/api/invitations")
      .then((response) => {
        console.log("Invitation response: ", response.data);
        const { contact_id, invitation_id, invitation_url } = response.data;

        firstAttempt
          ? setInvitations({
              firstInvitation: { contact_id, invitation_id, invitation_url },
              secondInvitation: {},
            })
          : setInvitations({
              firstInvitation: invitations.firstInvitation,
              secondInvitation: { contact_id, invitation_id, invitation_url },
            });
      })
      .catch((error) => {
        console.error("Invitation Error: ", error);
        setError(true);
      });
  };

  const requestCredVerification = (invitation) => {
    console.log(
      "Requesting credential verification...",
      invitation.invitation_id
    );
    const abortController = new AbortController();
    const signal = abortController.signal;

    Axios.post(
      "/api/verifications",
      {
        contact_id: invitation.contact_id,
        invitation_id: invitation.invitation_id,
      },
      { signal }
    )
      .then((res) => {
        console.log("Verifications response: ", res.data);

        const verifiedAttributes = {};
        res.data.verificationRecords[0].result_data.forEach((attribute) => {
          verifiedAttributes[attribute.name] = attribute.value;
        });

        setVerifiedCredAttributes(verifiedAttributes);
      })
      .catch((error) => {
        console.error("Verification Error: ", error);
        setError(true);
      });
  };

  const resetStates = () => {
    setError(false);
    setConnections({
      firstConnection: false,
      secondConnection: false,
    });
    setInvitations({
      firstInvitation: {},
      secondInvitation: {},
    });
    setVerifiedCredAttributes({});
  };

  useEffect(() => {
    if (error) {
      navigate("/error");
    }
  }, [error]);

  return (
    <ThemeProvider theme={theme}>
      <Frame id="app-frame">
        <Header />
        <Main>
          <Routes>
            <Route
              path="account/verified"
              element={
                <VerifiedPage
                  resetStates={resetStates}
                  verifiedCredAttributes={verifiedCredAttributes}
                />
              }
            />
            <Route
              path="error"
              element={<ErrorPage resetStates={resetStates} />}
            />
            <Route
              exact
              path="/"
              element={
                <LandingPage
                  connections={connections}
                  checkConnection={checkConnection}
                  fetchInvitation={fetchInvitation}
                  invitations={invitations}
                  requestCredVerification={requestCredVerification}
                  verifiedCredAttributes={verifiedCredAttributes}
                />
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Main>
        <Footer />
      </Frame>
    </ThemeProvider>
  );
}

export default App;
